import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { useTheme } from '@material-ui/core/styles';
import MuiSelect from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

import { DIMENSIONS } from '../../styles/constants';
import { useStyles } from './styles';

const Select = ({ button, buttonId, listId, value, items, multiple, fullWidth, ...rest }) => {
	const classes = useStyles();
	const theme = useTheme();
	const progressActive = useSelector(state => state.tabbar.progressActive);
	const MENU_PROPS = {
		MenuListProps: {
			id: listId,
			style: {
				padding: 0
			}
		},
		PaperProps: {
			style: {
				maxHeight: DIMENSIONS.SELECT_MENU_ITEM_HEIGHT * 7.5,
				boxShadow: theme.shadows[2]
			}
		},
		anchorOrigin: {
			vertical: 'bottom',
			horizontal: 'left'
		},
		transformOrigin: {
			vertical: 'top',
			horizontal: 'left'
		}
	};

	return (
		<FormControl fullWidth={fullWidth}>
			<MuiSelect
				color="secondary"
				disabled={progressActive || rest.disabled}
				style={{ display: button && buttonId && 'none' }}
				value={value}
				multiple={multiple}
				MenuProps={
					button && buttonId
						? {
								...MENU_PROPS,
								anchorEl: document.getElementById(buttonId),
								getContentAnchorEl: null
						  }
						: MENU_PROPS
				}
				classes={{ root: classes.selectRoot }}
				{...rest}>
				{items.map(item => (
					<MenuItem key={'select-item-' + item.value} value={item.value} disabled={item.disabled}>
						{multiple ? (
							<Fragment>
								<Checkbox color="primary" checked={item.checked || value.indexOf(item.value) !== -1} disableRipple />

								<ListItemText primary={item.label} />
							</Fragment>
						) : (
							<Typography variant="body2" className={classes.itemText}>
								{item.label}
							</Typography>
						)}
					</MenuItem>
				))}
			</MuiSelect>

			{button && buttonId && button}
		</FormControl>
	);
};

Select.propTypes = {
	button: PropTypes.node,
	buttonId: PropTypes.string,
	listId: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
	items: PropTypes.arrayOf(PropTypes.string).isRequired,
	multiple: PropTypes.bool,
	fullWidth: PropTypes.bool
};

export default Select;
